import React from 'react';
import EventButton from 'components/EventButton';

function PrimaryDialogButton(props) {
    return (
        <EventButton variant="contained" color="primary" {...props}>
            {props.children}
        </EventButton>
    );
}

export default PrimaryDialogButton;